export const HOME_VISIT = 'HOME_VISIT';
export const IN_CLINIC = 'IN_CLINIC';

export const F2FTypes = {
  HOME_VISIT,
  IN_CLINIC,
};
